export const Breakpoint = {
    mobileBreakpointMaxWidth: "991px",
    desktopBreakpointMinWidth: "992px",
    desktopBreakpoint: "992px",
    mediumScreenBreakpoint: "768px",
    mobileBreakpoint: "576px",
};
